export default __webpack_public_path__ + "static/media/searchIcon.239da99e.svg";